import { toastError, toastSuccess } from '@onestep/coreui/Toast';
import { map } from 'lodash';

import { ReactComponent as FallIcon } from '../../../../assets/icons/timeline/greenFallIcon.svg';
import useClinicalInfoService from '../../../../services/patientProfileService/clinicalInfo';
import useFallService from '../../../../services/patientProfileService/clinicalInfo/fall';
import { eventType } from '../NewEventModal';

export default function useFallEvent(patientUuid: string) {
  const { data } = useClinicalInfoService(patientUuid);
  const { deleteFall } = useFallService(patientUuid);

  const deleteFallEvent = async (uuid: string) => {
    try {
      await deleteFall(uuid);
      toastSuccess({ content: `The event Deleted Successfully!` });
    } catch (error) {
      toastError({ content: 'Failed to delete event!' });
    }
  };
  return map(data?.falls ?? [], ({ dateOfFall, description, uuid }) => ({
    name: 'Fall',
    date: dateOfFall,
    icon: FallIcon,
    description,
    id: uuid ?? '',
    tabName: eventType.fall,
    isToShowUpdateIcons: true,
    onDelete: deleteFallEvent,
  }));
}
